import { useState } from "react";

import { Button, Card, Group, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { IconInfoCircle } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import AddClientReminderNote from "./AddClientReminderNote";
import ArchiveClientReminderNote from "./ArchiveClientReminderNote";
import DisplayClientReminderNote from "./DisplayClientReminderNote";

export default function ClientReminderNotes() {
  const [toggleAddNote, setToggleAddNote] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [opened, handlers] = useDisclosure(false);

  const handleViewFiledReminders = () => {
    setRefresh((prev) => !prev);
    handlers.open();
  };

  return (
    <Card>
      <Group pb="xs" gap="xs">
        <TextWrapper fz="lg" variant="semibold">
          Reminders
        </TextWrapper>
        <Tooltip label="Not viewable to client · Not included in chart export">
          <IconInfoCircle />
        </Tooltip>
      </Group>
      {toggleAddNote ? (
        <AddClientReminderNote handleToggleReminder={() => setToggleAddNote(false)} />
      ) : (
        <DisplayClientReminderNote
          refresh={refresh}
          openModal={opened}
          setRefresh={setRefresh}
          modalHandlers={handlers}
        />
      )}
      <Group pt="xs" justify="space-between">
        <Button
          pl={0}
          color="black"
          variant="subtle"
          size="compact-xs"
          onClick={handleViewFiledReminders}
        >
          <TextWrapper size="sm" td="underline">
            View Filed Reminders
          </TextWrapper>
        </Button>
        {!toggleAddNote && (
          <Button
            color="black"
            variant="outline"
            size="compact-xs"
            onClick={() => setToggleAddNote(true)}
          >
            Add Reminder
          </Button>
        )}
      </Group>
      <ArchiveClientReminderNote
        refresh={refresh}
        openModal={opened}
        setRefresh={setRefresh}
        modalHandlers={handlers}
      />
    </Card>
  );
}
